import React, { useEffect, useState } from 'react';
import '../../App.css';
import './BettingShop.css';
import '../validate.css';
import axios from 'axios';
import { API_URL } from '../environment';
import withNavigation from './../withNavigation';


class BettingShop extends React.Component {

  state = {
    bettingShops: [],
    name: '', // State for the betting shop name
    address: '', // State for the address
    profitShare: '',
    lossShare: '',
    currentShopId: '',
    isEditing: false,
    bettingShopsNumber: 0,
  }

  constructor(props) {
    super(props);
  }

  async refreshBettingShops() {
    try {
      const response = await axios.get(`${API_URL}/bettingshopsinfo`); // Example API URL      
      let formattedData = (response.data || []).reverse();
      const nowTime = new Date().getTime();
      const ONLINE_STATUS = 'online';
      const OFFINE_STATUS = 'offline';

      formattedData = formattedData.map( o => {
        const date = new Date(o.createdAt);

        const formattedTime = new Intl.DateTimeFormat('en-US', {
          month: 'short',
          day: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        }).format(date);

        o.createdAtF = formattedTime;

        const lastActivity = o.lastActivityTime || null;
        const MINS_5 = 1000 * 60 * 5;

        if (lastActivity) {
          const timeOffset = nowTime - new Date(lastActivity).getTime();
          if (timeOffset <= MINS_5) {
            o.onlineStatus = ONLINE_STATUS;
          } else {
            o.onlineStatus = OFFINE_STATUS;
          }
        } else {
          o.onlineStatus = OFFINE_STATUS;
        }
        
        return o;
      } );

      const bettingShopsNumber = formattedData.length;
      this.setState({bettingShops: formattedData, bettingShopsNumber: bettingShopsNumber});


      // setData(formattedData); // Update state with fetched data
      // setLoading(false); // Set loading to false
    } catch (err) {
      console.log(err);
      // setError(err.message); // Update state with error message
      // setLoading(false); // Set loading to false
    }
  }

  async componentDidMount() {
    document.body.classList.add('validate-active');

    await this.refreshBettingShops();
  }

  componentWillUnmount() { 
    clearTimeout(this.timer);
  }

  navigateToPage = (page) => {
    this.props.navigate(page);    
  }

  // Handle changes to the inputs
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }); // Update the corresponding state
  };

  // Pass the state values to the onCreateBettingShop function
  handleCreateBettingShop = () => {
    const { name, address, profitShare, lossShare } = this.state;
    if (!(name && address)) {
      alert('Please fill all fields');
      return;
    }

    this.onCreateBettingShop(name, address, profitShare, lossShare); // Call the function with input values
  };

  onCreateBettingShop = async(name, address, profitShare, lossShare) => {
    console.log("Creating betting shop with details:");
    console.log("Name:", name);
    console.log("Address:", address);

    const response = await axios.post(`${API_URL}/bettingshops`, {name, address, profitShare, lossShare}); // Example API URL
    console.log('create response', response);
    this.setState({
      name: '',
      address: '',
      profitShare: 0,
      lossShare: 0,
    });
    await this.refreshBettingShops();
    const userId = localStorage.getItem("sun_userId");
    await axios.post(`${API_URL}/logaction`, {
      action: 'create_shop',
      data: name,
      user: userId,
    });
  };

  handleEdit = async(id) => {
    console.log("Editing shop with ID:", id);
    // Logic to handle editing the agent
    // For example, navigate to an edit form or pre-fill inputs with the agent's data

    // load data to the right popup
    const currentShop = this.state.bettingShops.find(o => o._id === id);

    this.setState({
      currentShopId: id,
      name: currentShop.name,
      address: currentShop.address,
      profitShare: currentShop.profitShare || 0,
      lossShare: currentShop.lossShare || 0,
      isEditing: true,
    });

    // const userId = localStorage.getItem("sun_userId");
    // await axios.post(`${API_URL}/logaction`, {
    //   action: 'edit_shop',
    //   data: currentShop.name,
    //   user: userId,
    // });
  };
  
  handleDelete = async (id) => {
    console.log("Deleting shop with ID:", id);
    try {
      // API call to delete the agent
      const response = await axios.delete(`${API_URL}/bettingshops`, {params: { id }},);
      
      console.log("Delete response:", response);
  
      // Refresh the list of agents after deletion
      await this.refreshBettingShops()
    } catch (error) {
      console.error("Error deleting agent:", error);
    }


    // PUT request with set active false

    // try {
    //   // API call to delete the agent
    //   const response = await axios.delete('http://localhost:3001/bettingshops', {params: { id }},);
      
    //   console.log("Delete response:", response);
  
    //   // Refresh the list of agents after deletion
    //   await this.refreshAgents();
    // } catch (error) {
    //   console.error("Error deleting agent:", error);
    // }
  };

  updateBettingShop = async() => {
    this.setState({ isEditing: !this.state.isEditing });

    let updateObj = {
      _id: this.state.currentShopId,
      name: this.state.name,
      address: this.state.address,
      profitShare: parseInt(this.state.profitShare, 10),
      lossShare: parseInt(this.state.lossShare,10),
    };

    try {
      const response = await axios.put(`${API_URL}/bettingshops`, updateObj);
      console.log('create response', response);  
    } catch (e) {
      console.error('edit shop error');
    }
    await this.refreshBettingShops();
    this.setState({
      name: '',
      address: '',
      currentShopId: '',
      profitShare: '',
      lossShare: '',
    });
  };

  onClickCancel = () => {
    // this.setState({ isEditing: false });
    this.setState({
      name: '',
      username: '',
      bettingShop: '',
      profitShare: '',
      lossShare: '',
      password: '',
      address: '',
      isEditing: false,
    });
  };

  render() {    
      return <>
      <div className="validate">
        <div className="validate-left">
          <div className="spin-border dashbord-border">
            <div className="spin-light spin-light-top">
              <div className="spin-light-container">
                {Array.from({ length: 15 }).map((_, index) => (
                  <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                ))}
              </div>
            </div>
            <div className="spin-number">
              <div className="spin-number__text">
                <span className="spin-number__text-big">BETTING SHOPS ({this.state.bettingShopsNumber})</span> 
              </div> 
            </div>
            <div className="spin-light spin-light-bottom">
              <div className="spin-light-container">
                {Array.from({ length: 15 }).map((_, index) => (
                  <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                ))}
              </div>
            </div>
          </div>

          <div className="table-maket">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Number Of Agents</th>
                <th>Profit Share</th>
                <th>Loss Share</th>
                <th>Status</th>
                <th>Address</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
            {this.state.bettingShops.map((item) => {
                // var keyId = 0;
                return (
                  <tr key={item._id}>
                    <td>
                    {item.name}
                    </td>
                    <td>
                    {item.agentsNumber || 0}
                    </td>
                    <td>
                    {item.profitShare || 0}
                    </td>
                    <td>
                    {item.lossShare || 0}
                    </td>
                    <td className={
                      item.onlineStatus === 'online' ? 'status-online' :
                      item.onlineStatus === 'offline' ? 'status-offline' :
                      ''
                    }>
                      {item.onlineStatus}
                    </td>
                    <td>
                    {item.address}
                    </td>
                    <td>
                    {item.createdAtF}
                    </td>
                    <td style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <button className="wrap-validate_item wrap-validate_item-mini" onClick={() => this.handleEdit(item._id)}>Edit</button>
                    <button className="wrap-validate_item wrap-validate_item-mini" onClick={() => this.handleDelete(item._id)}>Delete</button>
                    </td>
                  </tr>
                );
              })}

            </tbody>
          </table>
          </div>
        </div>
        <div className="validate-right">
          <button className="return-menu btn-yellow"
            onClick={() => this.navigateToPage('/dashboard')}>RETURN TO MAIN MENU</button>
           <div className="betting-form">
            <input className="betting-form__input betting-form__input-width" placeholder='Betting Shop Name'
              name="name" // Name must match the state key
              value={this.state.name}
              onChange={this.handleInputChange} // Handle input changes
            />
            <input className="betting-form__input betting-form__input-width" placeholder='Address'
              name="address" // Name must match the state key
              value={this.state.address}
              onChange={this.handleInputChange} // Handle input changes            
            />
            <input className="betting-form__input betting-form__input-width" placeholder='Profit Share'
              name="profitShare" // Name must match the state key
              value={this.state.profitShare}
              onChange={this.handleInputChange} // Handle input changes            
            />
            <input className="betting-form__input betting-form__input-width" placeholder='Loss Share'
              name="lossShare" // Name must match the state key
              value={this.state.lossShare}
              onChange={this.handleInputChange} // Handle input changes            
            />
            <div>
              {this.state.isEditing ? (
                <div className="um-edit-mode-wrap">
                  <button className="betting-form__btn btn-blue" onClick={this.updateBettingShop}>
                    Save
                  </button>
                  <button className="betting-form__btn btn-blue" onClick={this.onClickCancel}>
                    Cancel
                  </button>
                </div>
              ) : (
                <button className="betting-form__btn   btn-blue  " onClick={() => this.handleCreateBettingShop()}>Create</button>
              )}
            </div>
           </div>
        </div>
      </div>
      </>;
  }
}

export default withNavigation(BettingShop);
